var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0592 1.34122C5.24438 1.34122 1.34122 5.24438 1.34122 10.0592C1.34122 14.8739 5.24438 18.7771 10.0592 18.7771C14.8739 18.7771 18.7771 14.8739 18.7771 10.0592C18.7771 5.24438 14.8739 1.34122 10.0592 1.34122ZM0 10.0592C0 4.50364 4.50364 0 10.0592 0C15.6147 0 20.1183 4.50364 20.1183 10.0592C20.1183 15.6147 15.6147 20.1183 10.0592 20.1183C4.50364 20.1183 0 15.6147 0 10.0592Z",
    fill: "#768396"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6026 21.6555C22.3407 21.9174 21.9161 21.9174 21.6542 21.6555L17.2377 17.239C16.9758 16.9771 16.9758 16.5525 17.2377 16.2906C17.4996 16.0287 17.9242 16.0287 18.1861 16.2906L22.6026 20.7071C22.8645 20.969 22.8645 21.3936 22.6026 21.6555Z",
    fill: "#768396"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.716d65f0cd2b2067eed933b612baa2f5.svg";
export { ForwardRef as ReactComponent };